import SwapIcon from "@mui/icons-material/SwapHorizontalCircle";

import PfaActionMenuItem from "./PfaActionMenuItem";

export const PfaReplaceAction = ({ file }) => {
  return <PfaActionMenuItem file={file} Icon={SwapIcon} label="Replace" />;
};

export default PfaReplaceAction;
